/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const CHUNK_RELOAD_KEY = 'ep-chunk-reload';

function reloadOnce() {
  try {
    if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  } catch (e) {
    // sessionStorage can throw in private mode; still attempt a single reload
  }
  window.location.reload();
}

exports.onClientEntry = () => {
  if (typeof navigator !== 'undefined' && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister());
    }).catch(() => {});
  }

  window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason && (event.reason.message || String(event.reason));
    if (message && /Loading chunk|ChunkLoadError/.test(message)) {
      reloadOnce();
    }
  });
};
